import { GET, POST } from '../request'

export const getClasesFechas = ({ fechaInicio, fechaFin }) =>
  GET('/api/agora/planificacion/clase-profesor/list', { fechaInicio, fechaFin })

export const createClases = ({ profesor, asistencias }) =>
  POST(
    '/api/agora/planificacion/clase-profesor/planning',
    {},
    { profesor, asistencias }
  )
